/* ============================================================
   Firebase — client initialization.
   Config comes from Vite env vars (VITE_FIREBASE_*). These are
   PUBLIC client identifiers by design (they ship in the bundle);
   access is enforced by Firestore/Storage security rules, not by
   secrecy. Service instances (Auth, Firestore, Storage) are added
   in later phases as features need them.
   ============================================================ */
import { initializeApp } from 'firebase/app'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
}

export const app = initializeApp(firebaseConfig)
